import React, { useState, useRef, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSelector.css';

const LanguageSelector = () => {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const languages = useMemo(
    () => [
      { code: 'en', label: t('languages.en'), flag: '🇬🇧' },
      { code: 'hu', label: t('languages.hu'), flag: '🇭🇺' },
      { code: 'he', label: t('languages.he'), flag: '🇮🇱' }
    ],
    [t]
  );

  const current = languages.find((l) => i18n.language === l.code) || languages[0];

  return (
    <div className="language-selector" ref={ref} role="group" aria-label={t('languages.ariaGroup')}>
      <button
        type="button"
        className="lang-dropdown-trigger"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
        aria-haspopup="listbox"
        aria-label={t('languages.ariaCurrent', { lang: current.label })}
      >
        <span className="lang-flag">{current.flag}</span>
        <span className="lang-chevron">▼</span>
      </button>
      {open && (
        <ul className="lang-dropdown-menu" role="listbox">
          {languages.map((lang) => (
            <li key={lang.code} role="option">
              <button
                type="button"
                className={`lang-dropdown-item ${i18n.language === lang.code ? 'active' : ''}`}
                onClick={() => {
                  i18n.changeLanguage(lang.code);
                  setOpen(false);
                }}
              >
                <span className="lang-flag">{lang.flag}</span>
                <span className="lang-label">{lang.label}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSelector;
